const header = document.querySelector(".main-header-wrapper");
  const stickyOffset = header.offsetTop;

  window.addEventListener("scroll", function () {
    if (window.scrollY > stickyOffset) {
      header.classList.add("sticky-header");
    } else {
      header.classList.remove("sticky-header");
    }
  });


var script = document.createElement('script');
script.src = 'https://code.jquery.com/jquery-3.6.0.min.js';

script.onload = function() {
  jQuery(document).on('click', '.filter-option input[type="checkbox"]', function () {
    applyFilters();
  });

  jQuery(document).on('click', 'button.nv-mb-close-fillter', function () {
    jQuery(this).closest('.filter-section').find('h4').trigger('click');
  });

  jQuery(document).on('click', 'button.nv-mb-apply-fillter', function () {
    applyFilters();
    jQuery(this).closest('.filter-section').find('h4').trigger('click');
  });
  jQuery(document).on('click', 'button.nv-mb-clear-fillter', function () {
    clearAllFilters();
    jQuery(this).closest('.filter-section').find('h4').trigger('click');
  });

  jQuery(document).on('click', 'li.mobile-nav-item.has-subnav > a', function (event) {
  event.preventDefault();
  jQuery(this).parent().toggleClass('active');
});

};

document.head.appendChild(script);





//STart
  document.addEventListener('DOMContentLoaded', function() {
    // Only run on mobile devices
    if (window.innerWidth <= 767) {
      const announcementItems = document.querySelectorAll('.announcement-left, .announcement-center, .announcement-right');
      if (announcementItems.length <= 1) return;

      // Create slider container
      const sliderContainer = document.createElement('div');
      sliderContainer.className = 'announcement-simple-slider';

      // Create slider content area
      const sliderContent = document.createElement('div');
      sliderContent.className = 'announcement-slider-content';

      // Get parent of the announcement items
      const parent = announcementItems[0].parentElement;

      // Extract content for slides
      const slides = [];
      announcementItems.forEach(item => {
        const icon = item.querySelector('.announcement-icon');
        const text = item.querySelector('.announcement-text') || item.querySelector('.announcement-email');
        if (icon && text) {
          slides.push({
            icon: icon.cloneNode(true),
            text: text.cloneNode(true)
          });
        }

        // Hide original items on mobile
        item.classList.add('desktop-only');
      });

      // Create slide elements
      slides.forEach((slide, index) => {
        const slideEl = document.createElement('div');
        slideEl.className = 'announcement-slide';
        if (index === 0) {
          slideEl.classList.add('active');
        }

        // Add icon and text
        slideEl.appendChild(slide.icon);
        slideEl.appendChild(slide.text);

        sliderContent.appendChild(slideEl);
      });

      // Add dots navigation (optional - hidden by default)
      const dotsContainer = document.createElement('div');
      dotsContainer.className = 'slider-dots';

      for (let i = 0; i < slides.length; i++) {
        const dot = document.createElement('span');
        dot.className = 'slider-dot';
        if (i === 0) {
          dot.classList.add('active');
        }
        dot.setAttribute('data-index', i);
        dotsContainer.appendChild(dot);
      }

      // Assemble the slider
      sliderContainer.appendChild(sliderContent);
      sliderContainer.appendChild(dotsContainer);

      // Insert at the beginning of the announcement inner div
      parent.insertBefore(sliderContainer, parent.firstChild);

      // Initialize slider
      initSimpleSlider();
    }
  });

  function initSimpleSlider() {
    const slides = document.querySelectorAll('.announcement-slide');
    const dots = document.querySelectorAll('.slider-dot');
    let currentIndex = 0;

    // Auto-advance slides every 4 seconds
    setInterval(() => {
      currentIndex = (currentIndex + 1) % slides.length;
      updateSlider();
    }, 4000);

    // Function to update slide positions and active states
    function updateSlider() {
      // Remove active class from all slides and dots
      slides.forEach(slide => slide.classList.remove('active'));
      dots.forEach(dot => dot.classList.remove('active'));

      // Add active class to current slide and dot
      slides[currentIndex].classList.add('active');
      dots[currentIndex].classList.add('active');
    }
  }


  // -- END --